import React from 'react'

function Info({text, email}) {
  return (
    
<div className="panel-horizontal-content" style={{ backgroundColor: '#F3F6F9' }}>
  <div className="panel-horizontal">
  <p className="">{text}<strong>{email}</strong></p>
  </div>
</div>

  )
}

export default Info